import { deleteCookie, getCookie, setCookie } from 'stash/utils/cookies';

const BANK_LINK_COOKIE_AGE = 1000 * 60 * 30; // 30 minutes

// for oauth, plaid needs to resume with the same plaidToken that
// initiated the link session
const BANK_LINK_PLAID_TOKEN_NAME = 'stashBankLinkPlaidToken';

export function getBankLinkPlaidTokenCookie() {
	return getCookie(BANK_LINK_PLAID_TOKEN_NAME);
}

export const storeBankLinkPlaidToken = (plaidToken) => {
	setCookie(BANK_LINK_PLAID_TOKEN_NAME, plaidToken, {
		'max-age': BANK_LINK_COOKIE_AGE,
	});
};

export const deleteBankLinkPlaidToken = () => {
	deleteCookie(BANK_LINK_PLAID_TOKEN_NAME);
};

// in order for smaug to direct to the correct app, we need to set a cookie
// currently it checks that the stashBankLinkOrigin is `signup` to go to web-reg
export const storeBankLinkOrigin = () => {
	setCookie('stashBankLinkOrigin', 'signup');
};

// store auto stash configuration in sessionStorage so that if we come back
// from a redirect, we don't lose the values
export const FUNDING_AUTO_STASH_CONFIG = 'linkBank.autoStashConfig';
export const SKIP_TO_BANK_LINK_STASH_CONFIG = 'linkBank.skipToBankLinkConfig';

export const storeAutoStashConfig = (config) => {
	sessionStorage.setItem(FUNDING_AUTO_STASH_CONFIG, JSON.stringify(config));
};

export const storeSkipToBankLinkConfig = (config) => {
	sessionStorage.setItem(SKIP_TO_BANK_LINK_STASH_CONFIG, JSON.stringify(config));
};

export function getAutoStashConfig() {
	const value = sessionStorage.getItem(FUNDING_AUTO_STASH_CONFIG);
	try {
		return JSON.parse(value);
	} catch (error) {
		return null;
	}
}

export function getSkipToBankLinkConfig() {
	const value = sessionStorage.getItem(SKIP_TO_BANK_LINK_STASH_CONFIG);
	try {
		return JSON.parse(value);
	} catch (error) {
		return null;
	}
}

export const deleteAutoStashConfig = () => {
	sessionStorage.removeItem(FUNDING_AUTO_STASH_CONFIG);
};

export const deleteSkipToBankLinkConfig = () => {
	sessionStorage.removeItem(SKIP_TO_BANK_LINK_STASH_CONFIG);
};
